/**
 * !(i)
 * Код потрапляє до фінального файлу, тільки коли викликана функція, наприклад FLSFunctions.spollers();
 * Або коли імпортований весь файл, наприклад import "files/script.js";
 * Невикористаний код у фінальний файл не потрапляє.
 *
 * Якщо ми хочемо додати модуль, слід його розкоментувати.
 */

import "@/styles/main.scss";

// import MousePRLX from './libs/parallaxMouse'
// import AOS from 'aos'
// import Swiper, { Navigation, Pagination } from 'swiper';

import BaseHelpers from './helpers/base-helpers';
import PopupManager from './modules/popup-manager';
import BurgerMenu from './modules/burger-menu';
import './modules/post-scroll';
import SearchBar from './modules/search-bar';
import Splide from '@splidejs/splide';

BaseHelpers.checkWebpSupport();

BaseHelpers.addTouchClass();

BaseHelpers.addLoadedClass();

/**
 * BaseHelpers methods has intellisense descriptions
 */
BaseHelpers.headerScrollUpTrigger();
BaseHelpers.placeholderReplacer();
BaseHelpers.titleTapeProcessor();

/**
 * Відкриття/закриття модальних вікон
 * Щоб модальне вікно відкривалося і закривалося
 * На вікно додай атрибут data-popup="<назва вікна>"
 * На кнопку, яка викликає вікно, додай атрибут data-type="<назва вікна>"
 *
 * На обгортку (.popup) вікна додай атрибут '[data-close-overlay]'
 * На кнопку для закриття вікна додай клас '.button-close'
 * */
new PopupManager();

/**
 *  Модуль для роботи з меню (Бургер)
 * */
new BurgerMenu().init();

/**
 *  Search in header module
 * */
new SearchBar().init();

/**
 *  Бібліотека для анімацій
 *  документація: https://michalsnik.github.io/aos
 * */
// AOS.init();

/**
 * Параллакс для миші
 * */
// new MousePRLX();

document.addEventListener('DOMContentLoaded', function () {
    // Ініціалізація всіх слайдерів з класом .splide.primary-slider
    const postSliders = document.querySelectorAll('.splide.primary-slider');
    postSliders.forEach((slider) => {
        new Splide(slider).mount();
    });

    // Ініціалізація головного слайдера на основних сторінках
    const mainSlider = document.querySelector('.splide.main-articles--splide');
    if (mainSlider) {
        new Splide(mainSlider).mount();
    }

    // Ініціалізація відео-слайдера
    const videosSlider = document.querySelector('.splide.videos-articles--splide');
    if (videosSlider) {
        new Splide(videosSlider, {
            perPage: 1.5, // Кількість слайдів на сторінку
            focus: 'center', // Фокус на центральному слайді
            gap: 24, // Відступи між слайдами
            breakpoints: {
                768: {
                    perPage: 1, // На малих екранах показується 1 слайд
                },
            },
        }).mount();
    }

    // Ініціалізація кейс-слайдера
    const casesSlider = document.querySelector('.splide.cases--splide');
    if (casesSlider) {
        new Splide(casesSlider, {
            perPage: 3.3, // Кількість слайдів на сторінку
            focus: 'center', // Фокус на центральному слайді
            gap: 24, // Відступи між слайдами
            arrows: false, // Відключити стрілки
            breakpoints: {
                992: {
                    perPage: 2.8, // На середніх екранах показується 2.8 слайда
                },
                768: {
                    perPage: 2.2, // На планшетах показується 2.2 слайда
                },
                496: {
                    perPage: 1.2, // На телефонах показується 1.2 слайда
                },
            },
        }).mount();
    }
});